
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import AuthLayout from '@/components/auth/AuthLayout';
import { Spinner, useAuthT } from '@/components/auth/kit';
import { useUser } from '@/utils/useUser';
/**
 * Sign-up lives on /login (`#auth-sign-up`). This page forwards there with
 * its whole query string, so `redirectTo`, `preset`, `price`,
 * `promotionCode` and the rest reach the hand-offs /login stores for
 * /dashboard. It also stores the five it always stored, in case a visitor
 * leaves before the redirect lands.
 */
export default function Signup() {
    const router = useRouter();
    const { user } = useUser();
    const { t } = useAuthT();
    const { price, avatar, invite_code, join, headshots_join } = router.query;
    const [, setPriceValue] = useLocalStorage('price');
    const [, setAvatarValue] = useLocalStorage('avatar');
    const [, setInviteCodeValue] = useLocalStorage('invite_code');
    const [, setJoinValue] = useLocalStorage('join');
    const [, setHeadshotsJoinValue] = useLocalStorage('headshots_join');
    useEffect(() => {
        // Redirect to login page with sign-up mode, keeping the query string.
        router.replace(`/login${window.location.search}#auth-sign-up`);
        // Once, on arrival.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (price)
            setPriceValue(price);
    }, [price, setPriceValue]);
    useEffect(() => {
        if (avatar)
            setAvatarValue(avatar);
    }, [avatar, setAvatarValue]);
    useEffect(() => {
        if (invite_code)
            setInviteCodeValue(invite_code);
    }, [invite_code, setInviteCodeValue]);
    useEffect(() => {
        if (join)
            setJoinValue(join);
    }, [join, setJoinValue]);
    useEffect(() => {
        if (headshots_join)
            setHeadshotsJoinValue(headshots_join);
    }, [headshots_join, setHeadshotsJoinValue]);
    useEffect(() => {
        if (user)
            router.push('/dashboard');
    }, [user, router]);
    return (<AuthLayout title={t('Sign up')} panel={false}>
      <div role='status' className='flex justify-center py-16'>
        <Spinner className='h-7 w-7 text-primary-600 dark:text-primary-400'/>
        <span className='sr-only'>{t('Loading...')}</span>
      </div>
    </AuthLayout>);
}

    async function __Next_Translate__getStaticProps__1a168f612bd__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signup',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a168f612bd__ as getStaticProps }
  